import { PatternPuzzleState } from "@shared/types/PatternPuzzleState";
import { PlayerService } from "./PlayerService";

export default class PatternPuzzleService {
    private _playerService: PlayerService = new PlayerService();

    /**
     * Gets the pattern puzzle state from the API
     * @returns The pattern puzzle state
     */
    public async getState(): Promise<PatternPuzzleState> {
        return await fetch(`${VITE_API_URL}pattern-puzzle/state`, {
            headers: {
                "x-playersessionid": this._playerService.getPlayerSessionId(),
            },
        }).then(res => res.json() as Promise<PatternPuzzleState>);
    }

    /**
     * Rotates the keystone with the given index on the API
     * @param keystoneIndex An index of a keystone (must be a number between 0 and 2)
     * @returns The new pattern puzzle state
     */
    public async rotate(keystoneIndex: number): Promise<PatternPuzzleState> {
        return await fetch(`${VITE_API_URL}pattern-puzzle/rotate`, {
            method: "POST",
            headers: {
                "x-playersessionid": this._playerService.getPlayerSessionId(),
                "content-type": "application/json",
            },
            body: JSON.stringify({
                keystoneIndex,
            }),
        }).then(res => res.json() as Promise<PatternPuzzleState>);
    }
}
